import React from "react";
import { Spin } from "antd";

function GlobalLoading() {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin />
    </div>
  );
}

export default GlobalLoading;
